export default "__VITE_ASSET__BDn9T7q5__"